import uuid from 'uuid/v4';


// eslint-disable-next-line import/prefer-default-export
export const addUniqueKeyForArrayItems = array => array
  .map(elem => ({ id: uuid(), value: elem }));
